if(typeof window !== 'undefined'){
    (window as any).__zone_symbol__UNPATCHED_EVENTS=['resize'];
}
import 'zone.js';

(window as any).global = window